function initMap( $el ) {
    var $markers = $el.find('.marker');

    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    centerMap( map );

    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map,
        icon: '/wp-content/themes/tiz-actecil/assets/img/layout/map-marker.png'
    });

    map.markers.push( marker );

    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

$(document).ready(function() {

    // OFI
    objectFitImages();

    /*
        GLOBAL
     */
    $(".fancybox").fancybox();

    $(window).on('scroll', function() {
        let actualScroll = $(window).scrollTop();

        if (actualScroll > 30) {
            $('header#header').addClass('scroll');
        } else {
            $('header#header').removeClass('scroll');
        }

        scroll = actualScroll;
    });

    var scroll = $(window).scrollTop();

    if (scroll > 100) {
        $('header#header').addClass('scroll');
    } else {
        $('header#header').removeClass('scroll');
    }

    /*
       BLOCS
    */
    if ($('.slider-block').length > 0) {
        $('.slider-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-white.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-white.svg' />"],
            dots: true,
            animateOut: 'fadeOut',
            autoplay: true,
            autoplayTimeout: 8000,
            lazyLoad: true,
        });
    }

    if ($('.slider-bbc-block').length > 0) {
        $('.slider-bbc-block .owl-carousel').owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: false,
            animateOut: 'animate__fadeOutDown',
            animateIn: 'animate__fadeInDown',
            autoplay: true,
            autoplayTimeout: 5000,
            smartSpeed: 2000,
        });
    }


    if ($('.box-thumbnails-block').length > 0) {
        $('.box-thumbnails-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-blue.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-blue.svg' />"],
            dots: true,
            autoplay: false,
            margin: 20,
            responsive : {
                768 : {
                    items: 2
                },
                1199 : {
                    items: 3,
                    center: false,
                    stagePadding: 50
                }
            }
        });
    }


    if ($('.picto-text-block').length > 0) {
        let navTextArrows = [];

        if ($('.picto-text-block').hasClass('is-bbc')) {
            navTextArrows = ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-yellow.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-yellow.svg' />"];
        } else {
            navTextArrows = ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-blue.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-blue.svg' />"];
        }

        $('.picto-text-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: navTextArrows,
            dots: true,
            autoplay: false,
            margin: 20,
            lazyLoad: true,
            responsive : {
                768 : {
                    items: 2
                },
                1199 : {
                    items: 3
                }
            }
        });
    }


    if ($('.articles-block').length > 0) {
        $('.articles-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-blue.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-blue.svg' />"],
            dots: true,
            autoplay: false,
            margin: 32,
            lazyLoad: true,
            responsive : {
                768 : {
                    items: 2
                },
                1199 : {
                    items: 3,
                    stagePadding: 50
                }
            }
        });
    }


    if ($('.interview-block').length > 0) {
        $('.interview-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-interview.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-interview.svg' />"],
            dots: true,
            autoplay: false,
            margin: 20,
        });
    }

    if ($('.product-thumbnails-block').length > 0) {
        $('.product-thumbnails-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-blue.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-blue.svg' />"],
            dots: true,
            autoplay: false,
            margin: 20,
            lazyLoad: true,
            responsive : {
                768 : {
                    items: 2
                },
                1199 : {
                    items: 3,
                    stagePadding: 50
                }
            }
        });
    }

    if ($('.next-formations-block').length > 0) {
        $('.next-formations-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-blue.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-blue.svg' />"],
            dots: true,
            autoplay: false,
            margin: 20,
            responsive : {
                768 : {
                    items: 2
                },
                1199 : {
                    items: 3,
                    stagePadding: 50
                }
            }
        });
    }

    if ($('.formations-v2-block').length > 0) {
        $('.formations-v2-block .owl-carousel').owlCarousel({
            items: 1,
            loop: false,
            nav: false,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-left-carousel-white.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/icon-arrow-right-carousel-white.svg' />"],
            dots: true,
            lazyLoad: true,
            margin: 32,
            responsive : {
                1199 : {
                    items: 2
                }
            }
        });
    }

    if ($('.testimonials-carousel-v2-block').length > 0) {
        $('.testimonials-carousel-v2-block .items').owlCarousel({
            items: 1,
            loop: false,
            nav: true,
            navText: ["<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/arrow-left-blue-v2.svg' />", "<img src='/wp-content/themes/tiz-actecil/assets/svg/layout/arrow-right-blue-v2.svg' />"],
            dots: false,
            autoplay: false,
            lazyLoad: true,
            margin: 50,
            responsive : {
                1199 : {
                    items: 2
                }
            }
        });
    }

    if ($('.partners-v2-block').length > 0) {
        $('.partners-v2-block .partners-logos').owlCarousel({
            items: 2,
            loop: true,
            dots: true,
            nav: false,
            autoplay: true,
            autoplayTimeout: 3000,
            lazyLoad: true,
            margin: 20,
            responsive : {
                768 : {
                    items: 3
                },
                1199 : {
                    items: 5
                }
            }
        });
    }

    if ($('.filters-wrapper').length > 0) {
        $('.filters-wrapper .filters-form select').on('change', function() {
            $(this).closest('form').find('input[name="paged"]').val(1);
            $(this).closest('form').submit();
        });


        $('.filters-wrapper .reinit-filters').on('click', function() {
            $(this).closest('form').find('select').val('');
            $(this).closest('form').find('input[name="paged"]').val(1);
            $(this).closest('form').submit();
            return false;
        });
    }

    $('.js-share-twitter-link').on('click', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        openCenterWindow(href, "Twitter", 550, 285);
    });

    $('.js-share-linkedin-link').on('click', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        openCenterWindow(href, "LinkedIn", 550, 285);
    });

    $('.js-share-facebook-link').on('click', function(e) {
        e.preventDefault();
        var href = $(this).attr('href');
        openCenterWindow(href, "Facebook", 550, 475);
    });


    $('label.file-upload input[type="file"]').change(function(e){
        var fileName = e.target.files[0].name;
        $(this).closest('.file-upload').find('.filename').text(fileName);
        $(this).closest('.file-upload').find('.field-name').hide();
    });

    if ($('#map-wrapper #map').length > 0) {
        var map = initMap($('#map-wrapper #map'));
    }

    $('header#header .right-part nav.navbar .navbar-toggler, header#header #header-top-part .navbar-toggler').on('click', function() {
        if ($(window).width() < 1090 && $(this).attr('aria-expanded') == 'false') {
            $('body').addClass('menu-open');
        } else {
            $('body').removeClass('menu-open');
        }
    });


    $('#search-modal .modal-body .step-1 .btn').on('click', function() {
        if ($(this).attr('href') == '#search') {
            $(this).closest('.step-1').fadeOut(500, function() {
                $('#search-modal .step-search').fadeIn();
            });
            return false;
        } else if ($(this).attr('href') == '#entonnoir') {
            $(this).closest('.step-1').fadeOut(500, function() {
                $('#search-modal .step-entonnoir > .btn').show();
                $('#search-modal .step-entonnoir .submenu').hide();
                $('#search-modal .step-entonnoir').fadeIn();
            });
            return false;
        }
    });


    $('#search-modal .modal-body .step-search .return-back').on('click', function() {
        $(this).closest('.step-search').fadeOut(500, function() {
            $('#search-modal .step-1').fadeIn();
        });

        return false;
    });

    $('#search-modal .modal-body .step-entonnoir .return-back').on('click', function() {
        if ($('#search-modal .modal-body .step-entonnoir .submenu:visible').length > 0) {
            var active_menu = $('#search-modal .modal-body .step-entonnoir .submenu:visible').attr('id');

            $('#search-modal .modal-body .step-entonnoir .submenu:visible .btn').hide();
            $('#search-modal .modal-body .step-entonnoir .submenu:visible').hide();

            if ($('#search-modal .modal-body .step-entonnoir .btn[href="#'+active_menu+'"]').closest('.submenu').length > 0) {
                $('#search-modal .modal-body .step-entonnoir .btn[href="#'+active_menu+'"]').closest('.submenu').find('.btn').show();
                $('#search-modal .modal-body .step-entonnoir .btn[href="#'+active_menu+'"]').closest('.submenu').show();
            } else {
                $('#search-modal .modal-body .step-entonnoir > .btn').show();
            }
        } else {
            $(this).closest('.step-entonnoir').fadeOut(500, function() {
                $('#search-modal .step-1').fadeIn();
            });
        }

        return false;
    });

    $('#search-modal .modal-body .step-entonnoir .btn.custom').on('click', function() {
        var attr_href = $(this).attr('href');

        $(this).closest('.step-entonnoir').find('.btn, .submenu').hide();

        $('#search-modal .modal-body .step-entonnoir .submenu'+attr_href+' .btn').show();
        $('#search-modal .modal-body .step-entonnoir .submenu'+attr_href).fadeIn();

        return false;
    });

    $('#search-modal').on('hidden.bs.modal', function (e) {
        $(this).closest('#search-modal').find('.step-entonnoir').hide();
        $(this).closest('#search-modal').find('.step-search').hide();
        $(this).closest('#search-modal').find('.step-1').show();
    });

    $('#go-to-top').on('click', function () {
        $('html, body').animate({scrollTop: 0});

        return false;
    });


    if ($('body.page-id-601').length > 0) {
        $(document).ready(function () {
            if (window.location.href.includes('page') || document.referrer.includes('page') )
                $('html, body').animate({scrollTop: $('.formations-block').offset().top - 30});
        });
    }
});


function openCenterWindow(url, title, width, height) {
    var left = (screen.width - width) / 2;
    var top = (screen.height - height) / 2;

    window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width='+width+', height='+height+', top='+top+', left='+left);
}


$(document).on('click', 'body.single-actecil_formation .text-promote-block .download-product-pdf-button', function() {
    const pdf_url = $(this).data('url-pdf');

    $('#download-product-pdf-modal').find('form input[data-name="url_pdf"]').val(pdf_url);

});